// ----------------------------------------------------------------------

function path(root: string, sublink: string) {
  return `${root}${sublink}`;
}

export const BASE_URL = '';
export const PATH_IMAGES = `${process.env.PUBLIC_URL}/assets2/images`;
export const PATH_ICONS = `${process.env.PUBLIC_URL}/assets2/icons`;
export const PATH_BACKGROUND = `${process.env.PUBLIC_URL}/assets2/background`;
export const PATH_ILLUSTRATIONS = `${process.env.PUBLIC_URL}/assets2/illustrations`;
export const PATH_BLOG_ASSETS = `${process.env.PUBLIC_URL}/assets2/blog`;

const ROOTS_BLOG = `${BASE_URL}`;

// ----------------------------------------------------------------------

export const PATH_BLOG = {
  blog: ROOTS_BLOG,
  post: {
    root: path(ROOTS_BLOG, '/:slug'),
    view: (slug: string) => path(ROOTS_BLOG, `/${slug}`),
  },
};

export const PATH_PAGE = {
  home: `${BASE_URL}/`,
  public: `${BASE_URL}/public/:id`,
  privacy: `${BASE_URL}/privacy`,
  terms: `${BASE_URL}/terms`,
  contact: `${BASE_URL}/contact`,
  page403: '/403',
  page404: '/404',
  page500: '/500',
};
